<template>
  <span>
    <div
      v-if="
        display_in == 'settings_calendars' &&
          is_show_todo_notice('add_calendar_account')
      "
      class="ob-checklist-inline-cont"
    >
      You can, optionally, connect your Google Calendar account to sync your
      events.
      <a
        style="margin-left:10px;"
        type="button"
        @click="dismiss_todo('add_calendar_account')"
      >
        Dismiss
      </a>
    </div>

    <div
      v-if="
        display_in == 'settings_integrations' &&
          is_show_todo_notice('add_meeting_app')
      "
      class="ob-checklist-inline-cont"
    >
      Connect your meeting app accounts to use them as locations. When you
      invitees book with you, we'll email them the meeting links.
      <a
        type="button"
        @click="dismiss_todo('add_meeting_app')"
        style="margin-left:10px;"
      >
        Dismiss
      </a>
    </div>

    <div
      v-if="
        display_in == 'settings_admins' &&
          is_show_todo_notice('add_wpcal_admin')
      "
      class="ob-checklist-inline-cont"
    >
      Add your teammates to manage their own/others event types and bookings.
      <a
        type="button"
        @click="dismiss_todo('add_wpcal_admin')"
        style="margin-left:10px;"
      >
        Dismiss
      </a>
    </div>

    <div
      class="ob-checklist-cont"
      v-if="display_in == 'admin_all' && is_show_onboarding_checklist"
    >
      <div class="ob-checklist-close-cont">
        <button @click="show_dismiss_confirm"></button>
      </div>
      <div class="hdr">
        <div class="ln1">{{ T__("Let's get you started...") }}</div>
        <!-- <div class="ln2">{{ T__("Setup your booking in 5 easy steps") }}</div> -->
      </div>
      <ul>
        <!-- <li class="completed"><a>Setup working days & hours</a></li> -->
        <li :class="[todo_class('create_or_edit_service')]">
          <router-link to="/event-type/add">{{ T__("Create") }}</router-link>
          or <router-link to="/event-types">{{ T__("Edit") }}</router-link> an
          Event Type
        </li>
        <li :class="[todo_class('add_calendar_account')]">
          <router-link to="/settings/calendars"
            >{{ T__("Connect calendar account") }}
          </router-link>
          <!-- <span class="mini-text">&nbsp;(Optional)</span> -->
        </li>
        <li :class="[todo_class('add_meeting_app')]">
          <router-link to="/settings/integrations"
            >{{ T__("Connect meeting app account") }}
          </router-link>
          <!-- <span class="mini-text">&nbsp;(Optional)</span> -->
        </li>
        <li :class="[todo_class('test_booking')]">
          <span class="pseudo-a" @click="show_test_booking_steps">{{
            T__("Test a booking")
          }}</span>
        </li>
        <li :class="[todo_class('add_wpcal_admin')]">
          <router-link to="/settings/admins">{{
            T__("Add your teammates")
          }}</router-link>
        </li>
        <!-- <li class="coming-up"><a>Connect meeting app account</a></li> -->
      </ul>
    </div>

    <div
      v-if="display_in == 'admin_all' && is_show_onboarding_checklist"
      style="height:250px;"
    ></div>
  </span>
</template>

<script>
import axios from "axios";

export default {
  name: "OnBoardingCheckList",
  props: {
    display_in: {
      type: String,
      default: "admin_all"
    }
  },
  computed: {
    is_show_onboarding_checklist() {
      if (this.$store.getters.get_license_info === null) {
        //propably not data not loaded
        return false;
      }
      if (this._isEmpty(this.$store.getters.get_license_info)) {
        //initial setup not done, another page gonna ask admin for login
        return false;
      }

      if (!this.onboarding_checklist_notice) {
        return false;
      }

      if (
        this.onboarding_checklist_notice?.status &&
        (this.onboarding_checklist_notice.status == "dismissed" ||
          this.onboarding_checklist_details?.status == "completed")
      ) {
        return false;
      }

      return true;
    },
    onboarding_checklist_notice() {
      let current_admin_notices = this.$store.getters.get_current_admin_notices;

      if (current_admin_notices == null) {
        //not yet loaded
        return false;
      }

      if (current_admin_notices?.onboarding_checklist) {
        return current_admin_notices?.onboarding_checklist;
      }

      return false;
    },
    onboarding_checklist_details() {
      let onboarding_checklist_details = this.onboarding_checklist_notice
        ?.details;

      return onboarding_checklist_details;
    }
  },
  methods: {
    todo_class(todo) {
      if (
        this.onboarding_checklist_details?.[todo] == "completed" ||
        this.onboarding_checklist_details?.[todo] == "dismissed"
      ) {
        return "completed";
      } else if (!this.onboarding_checklist_details.hasOwnProperty(todo)) {
        return "hide";
      }
      return "";
    },
    is_show_todo_notice(todo) {
      if (!this.is_show_onboarding_checklist) {
        return false;
      }
      if (!this.onboarding_checklist_details?.[todo]) {
        return false;
      }
      if (
        this.onboarding_checklist_details?.[todo] == "completed" ||
        this.onboarding_checklist_details?.[todo] == "dismissed"
      ) {
        return false;
      }
      return true;
    },
    dismiss_todo(todo) {
      let wpcal_request = {};
      let action = "update_admin_notices";
      let onboarding_checklist_notice = this.clone_deep(
        this.onboarding_checklist_notice
      );

      onboarding_checklist_notice.details[todo] = "dismissed";

      wpcal_request[action] = {
        onboarding_checklist: onboarding_checklist_notice
      };

      let action2 = "get_admin_notices";
      wpcal_request[action2] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(response.data[action], {
            success_msg: this.T__("Successfully dismissed.")
          });
          if (
            response.data[action2].status === "success" &&
            response.data[action2].hasOwnProperty("current_admin_notices")
          ) {
            this.$store.commit("set_store_by_obj", {
              current_admin_notices:
                response.data[action2].current_admin_notices
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    dismiss_onboarding() {
      let wpcal_request = {};
      let action = "update_admin_notices";
      let onboarding_checklist_notice = this.clone_deep(
        this.onboarding_checklist_notice
      );

      onboarding_checklist_notice.status = "dismissed";

      wpcal_request[action] = {
        onboarding_checklist: onboarding_checklist_notice
      };

      let action2 = "get_admin_notices";
      wpcal_request[action2] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(response.data[action], {
            success_msg: this.T__("Successfully dismissed.")
          });
          if (
            response.data[action2].status === "success" &&
            response.data[action2].hasOwnProperty("current_admin_notices")
          ) {
            this.$store.commit("set_store_by_obj", {
              current_admin_notices:
                response.data[action2].current_admin_notices
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    update_notices_silently() {
      let wpcal_request = {};
      let action = "get_admin_notices";
      wpcal_request[action] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data, {
          params: { _remove_options_before_call: { background_call: true } }
        })
        .then(response => {
          if (
            response.data[action].status === "success" &&
            response.data[action].hasOwnProperty("current_admin_notices")
          ) {
            this.$store.commit("set_store_by_obj", {
              current_admin_notices: response.data[action].current_admin_notices
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    check_and_may_update_notices(todo) {
      if (this.is_show_todo_notice(todo)) {
        this.update_notices_silently();
      }
    },
    show_dismiss_confirm() {
      this.$modal.show("dialog", {
        title: this.T__("Do you want to dismiss get you started list?"),
        text: "",
        buttons: [
          {
            title: this.T__("Yes, Dismiss."),
            class: "vue-dialog-button",
            handler: () => {
              this.dismiss_onboarding();
              this.$modal.hide("dialog");
            }
          },
          {
            title: "No, don't.",
            handler: () => {
              this.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    show_test_booking_steps() {
      this.$modal.show("dialog", {
        title: this.T__("Do a test booking?"),
        text:
          '<ol> <li>Choose a desired event type or create one.</li> <li>Click on "View Booking Page" of desired event type.</li> <li>Complete the booking steps by choosing the date & time and filling out the form.</li> <li>You can find the booking in the admin end WPCal &#62; Bookings section.</li> </ol>',
        buttons: [
          {
            title: this.T__("Okay"),
            class: "vue-dialog-button",
            handler: () => {
              if (this.$route.name !== "service_list") {
                this.$router.push("/event-types");
              }
              this.$modal.hide("dialog");
            },
            default: true // Will be triggered by default if 'Enter' pressed.
          }
        ]
      });
    }
  },
  mounted() {
    this.event_bus.$on("may_update_onboarding_checklist_notice", todo => {
      this.check_and_may_update_notices(todo);
    });
  }
};
</script>

<style scoped>
.ob-checklist-cont {
  font-family: "Rubik";
  position: fixed;
  bottom: 0;
  right: 10%;
  background-color: #fff;
  border: 1px solid #b1b6d1;
  border-radius: 5px 5px 0 0;
  border-bottom: 0;
  z-index: 1;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
.ob-checklist-cont .hdr {
  background-color: #567bf3;
  color: #fff;
  padding: 10px 15px;
  border-radius: 5px 5px 0 0;
  margin: -1px;
}
.ob-checklist-cont .hdr .ln1 {
  font-size: 16px;
}
.ob-checklist-cont .hdr .ln2 {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  padding-top: 3px;
}
.ob-checklist-cont ul {
  margin: 0;
  padding: 20px 20px 10px 20px;
  counter-reset: step-counter;
}
.ob-checklist-cont ul li {
  list-style: disc;
  list-style-position: inside;
  font-size: 15px;
  padding-bottom: 10px;
  counter-increment: step-counter;
  color: #131336;
  /* padding-left: 20px; */
  margin-bottom: 0px; /* theme conflict */
}
.ob-checklist-cont ul li a,
.ob-checklist-cont ul li .pseudo-a {
  color: #131336 !important;
  font-size: 15px !important;
}
.ob-checklist-cont ul li a:hover,
.ob-checklist-cont ul li .pseudo-a:hover {
  text-decoration: underline;
  cursor: pointer;
}
.ob-checklist-cont ul li::before {
  /* content: counter(step-counter); */
  position: absolute;
  width: 20px;
  height: 20px;
  border: 1px solid #131336;
  border-radius: 50%;
  margin-left: -27px;
  text-align: center;
  line-height: 1.5em;
  margin-top: -2px;
}
.ob-checklist-cont ul li.completed::before {
  content: "";
  background-color: #6ab04c;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 9.75 7.19'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3EAsset 1%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M3,7.19a1.51,1.51,0,0,1-1.06-.44L.22,5A.75.75,0,0,1,1.28,4L3,5.69,8.47.22A.75.75,0,0,1,9.53,1.28L4.06,6.75A1.51,1.51,0,0,1,3,7.19Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  border: 1px solid #6ab04c;
  background-size: 12px;
  background-repeat: no-repeat;
  background-position: 4px 5px;
}
.ob-checklist-cont ul li.completed,
.ob-checklist-cont ul li.completed a {
  text-decoration: line-through !important;
  color: #7c7d9c !important;
}
.ob-checklist-cont ul li.hide {
  display: none;
}
.ob-checklist-cont ul li.coming-up {
  opacity: 0.5;
}
/* .ob-checklist-cont ul li .mini-text {
  font-size: 9px;
} */
.ob-checklist-inline-cont {
  background-color: rgb(228, 233, 245);
  border: 1px dashed rgb(86, 123, 243);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
  display: inline-block;
}
</style>
